import { Component, h, Host } from '@stencil/core';

import { addClass, hasClass, removeClass } from '../../helpers/helpers';

@Component({
  tag: 'cms-toggle-theme',
  styleUrl: 'cms-toggle-theme.scss',
  shadow: true,
})
export class CmsToggleTheme {
  private hostname: string;
  private stage: string;
  private nodeBody: HTMLBodyElement;
  private pageWrapper: HTMLElement;

  private themeButtonIsVisible: boolean;

  private readonly themes = {
    'cms-light-theme': 'Base',
    'cms-dark-theme': 'Dark',
    'cms-light-grey-theme': 'Light-Grey',
    'cms-middle-grey-theme': 'Middle-Grey',
  };

  private getStage(hostname: string) {
    return hostname === 'localhost' ? hostname : hostname.split('.')[0];
  }

  private toggleThemeClass(event: Event) {
    const target = event.target as HTMLSelectElement;
    const className = target.value;
    for (const theme of Object.keys(this.themes)) {
      if (hasClass(this.nodeBody, theme)) {
        removeClass(this.nodeBody, theme);
      }
    }
    this.pageWrapper?.style.setProperty(
      'background-color',
      'var(--cms-theme-background-color)',
    );
    this.nodeBody?.style.setProperty(
      'background-color',
      'var(--cms-theme-background-color)',
    );
    addClass(this.nodeBody, className);
  }

  private checkStage(stage: string) {
    this.themeButtonIsVisible = ['localhost', 'dev', 'int'].includes(stage);
  }

  componentWillLoad() {
    this.hostname = window.location.hostname;
    this.stage = this.getStage(this.hostname);
    this.nodeBody = document.querySelector('body');
    this.pageWrapper = document.querySelector('.container-fluid');
    this.checkStage(this.stage);
  }
  render() {
    return (
      <Host>
        {this.themeButtonIsVisible === true ? (
          <div class={'theme-toggle-wrapper'}>
            <select
              class={'toggle-theme'}
              onChange={(_event) => {
                this.toggleThemeClass(_event);
              }}
            >
              {Object.keys(this.themes).map((theme) => (
                <option key={theme} value={theme}>
                  {this.themes[theme]}
                </option>
              ))}
            </select>
          </div>
        ) : null}
      </Host>
    );
  }
}
